import { IOption } from '@shared/interfaces';
import { IWorkflowStep } from './types';

export const sortSteps = (steps: IWorkflowStep[]): IWorkflowStep[] => {
  if (steps?.length) {
    return steps.slice().sort((a, b) => {
      if (a.orderNumber === b.orderNumber) {
        return a.numericId - b.numericId;
      }
      return a.orderNumber - b.orderNumber;
    });
  }
  return [];
};

export const workflowStepTreeOptions = (steps?: IWorkflowStep[], parentName = '') => {
  let options: IOption[] = [];
  steps?.forEach((step) => {
    const name = parentName ? parentName + ' → ' + step.name : step.name;

    options.push({
      value: step.id,
      label: `${name} [${step.numericId}]`
    });

    if (step?.childSteps?.length > 0) {
      const nestedOptions = workflowStepTreeOptions(step.childSteps, name);
      options = options.concat(nestedOptions);
    }
  });

  return options;
};
